// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3pvmn","inputWrap":"CustomTip_inputWrap__3LniR"};